import React from 'react';
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';


export const ChevronsLeft24 = (props: SvgIconProps): JSX.Element => React.createElement(SvgIcon, props, <svg viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'><path fillRule='evenodd' clipRule='evenodd' d='M11.707 7.707a1 1 0 0 0-1.414-1.414l-5 5a1 1 0 0 0 0 1.414l5 5a1 1 0 0 0 1.414-1.414L7.414 12l4.293-4.293Zm7 0a1 1 0 0 0-1.414-1.414l-5 5a1 1 0 0 0 0 1.414l5 5a1 1 0 0 0 1.414-1.414L14.414 12l4.293-4.293Z' /></svg>);
